module.exports = __webpack_public_path__ + "img/2-mob-wide.a7e039d4.png";